<template>
  <div>
    <!-- header -->
    <head-menu></head-menu>

    <!-- banner -->
    <div class="page-head">
      <img src="@/common/imgs/contact.jpg" alt="">
    </div>

    <!-- content -->
    <div class="news-content">
      <div class="news-left">
        <dl>
          <dt>
            <h3>联系我们</h3>
            <p>Contact Us</p>
          </dt>
          <dd class="w50">
            <router-link to="ShenZhen" class="active"><span>深圳总部</span><i class="el-icon-arrow-right"></i></router-link>
          </dd>
          <dd class="w50">
            <router-link to="ShenShan"><span>深汕合作区</span><i class="el-icon-arrow-right"></i></router-link>
          </dd>
        </dl>
      </div>

      <div class="news-right">
        <div class="news-bread">
          <h2>联系我们</h2>/<i>深圳市华剑建设集团股份有限公司</i>
        </div>
        <div class="txt-descrip">
          <h3>深圳总部</h3>
          <p>地址：深圳市福田区梅林街道中康路卓越城一期4号楼</p>
          <p>邮编：518000</p>
          <p>电话：0755-8321 1333</p>
          <p>传真：0755-8325 6860</p>
          <p>邮箱：hj009@szhuajian.com</p>
          <div class="map">
            <iframe width='560' height='440' frameborder='0' scrolling='no' marginheight='0' marginwidth='0' src='https://lbs.amap.com/console/show/map/?1_560_440_114.059446_22.571861&=%E6%B7%B1%E5%9C%B3%E5%B8%82%E5%8D%8E%E5%89%91%E5%BB%BA%E8%AE%BE%E9%9B%86%E5%9B%A2%E8%82%A1%E4%BB%BD%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8&=%E6%A2%85%E6%9E%97%E8%A1%97%E9%81%93%E4%B8%AD%E5%BA%B7%E8%B7%AF%E5%8D%93%E8%B6%8A%E5%9F%8E%E4%B8%80%E6%9C%9F4%E5%8F%B7%E6%A5%BC&=&=&='></iframe>
          </div>
        </div>
      </div>
    </div>

    <!-- footer -->
    <foot-link></foot-link>
     <!-- 回到顶部 -->
    <el-backtop></el-backtop>
    <router-view></router-view>
  </div>
</template>

<script>
  import Header from '@/components/Header'
  import Footer from '@/components/Footer'
  export default {
    name: 'ShenZhen',
    data() {
      return {}
    },
    components: {
      'head-menu': Header,
      'foot-link': Footer
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/ShenZhen.vue